import { useEffect, useState } from 'react'

export const deviceSize = {
  xsPhone: 390,
  phone: 600,
  phoneUpperBoundary: 600,
  biggerPhoneUpBoundary: 769,
  tabletPortraitUpperBoundary: 900,
  tabletLandscapeUpperBoundary: 1200,
  desktopUpperBoundary: 1800,
}

/**
 * @deprecated Use css media queries instead of this hook
 */
export const useDeviceSize = () => {
  const [windowSize, setWindowSize] = useState({
    windowWidth: 0,
    windowHeight: 0,
  })
  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        windowWidth: window.innerWidth,
        windowHeight: window.innerHeight,
      })
    }
    const handleOrientationChange = (e: Event) => {
      const target = e.target as ScreenOrientation | null
      const isPortrait =
        target &&
        (target.type === 'portrait-primary' ||
          target.type === 'portrait-secondary')

      setWindowSize({
        windowWidth: isPortrait ? screen.availWidth : screen.availHeight,
        windowHeight: isPortrait ? screen.availHeight : screen.availWidth,
      })
    }

    window.addEventListener('resize', handleResize)
    handleResize()
    if (window.screen.orientation) {
      window.screen.orientation.addEventListener(
        'change',
        handleOrientationChange
      )
    }
    // Remove event listener on cleanup
    return () => {
      window.removeEventListener('resize', handleResize)
      if (window.screen.orientation) {
        window.screen.orientation.removeEventListener(
          'change',
          handleOrientationChange
        )
      }
    }
  }, [])
  return windowSize
}
